import { render } from "./AddExpert.vue?vue&type=template&id=d8148e1e&scoped=true"
import script from "./AddExpert.vue?vue&type=script&lang=js"
export * from "./AddExpert.vue?vue&type=script&lang=js"

import "./AddExpert.vue?vue&type=style&index=0&id=d8148e1e&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8148e1e"]])

export default __exports__